import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgForm, NgModel } from '@angular/forms';
import { FacilitiesRoutingModule } from './facilities-routing.module';
import { FacilitiesComponent } from './facilities.component';
import { FacilitiesEventsComponent } from './events/events.component';
import { FacilitiesParkingComponent } from './parking/parking.component'
import { FacilitiesIssueComponent } from './issue/issue.component'
import { FacilitiesEventService } from '../../services/facilities.event.services';
import { FacilitiesParkingService } from '../../services/facilities.parking.services';
import { FacilitiesIssueService } from '../../services/facilities.issue.services';
import { SharedFormsModule } from '../../components/shared.forms.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../../shared/shared.module'

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgbModule,      
        FacilitiesRoutingModule,
        SharedFormsModule,
        SharedModule
    ],
    declarations: [
        FacilitiesComponent,        
        FacilitiesEventsComponent,
        FacilitiesParkingComponent,
        FacilitiesIssueComponent,
    ],
    providers: [
        FacilitiesEventService,
        FacilitiesParkingService,
        FacilitiesIssueService

    ]
})
export class FacilitiesModule { }
